import React from 'react';
import { Section, FadeIn } from './ui';
export const ProblemSection = () => {
  const stats = [{
    stat: '67%',
    text: 'Mujeres que reportan agotamiento emocional crónico'
  }, {
    stat: '71%',
    text: 'Madres que sienten que sus necesidades nunca son prioridad'
  }, {
    stat: '40%',
    text: 'Mujeres cuidadoras que desarrollan ansiedad o depresión'
  }, {
    stat: '58%',
    text: 'Mujeres que no recuerdan su último momento de descanso real'
  }];
  return <Section className="bg-navy-900 text-cream-100" data-id="element-195">
      <FadeIn data-id="element-196">
        <h2 className="text-3xl sm:text-4xl mb-6 text-center text-white" data-id="element-197">
          Lo que estás viviendo no es normal.
        </h2>
        <p className="text-lg sm:text-xl text-center text-cream-100/80 mb-6 sm:mb-12" data-id="element-198">
          No en el sentido de que algo está mal contigo. Sino en el sentido de
          que no tienes que seguir viviéndolo. Lo que sientes tiene nombre:
        </p>

        <div className="border-2 border-amber-400/50 rounded-xl sm:rounded-2xl p-5 sm:p-12 text-center mb-8 sm:mb-16 bg-navy-800/50 backdrop-blur-sm" data-id="element-199">
          <h3 className="text-2xl sm:text-5xl font-serif text-amber-400 mb-4 sm:mb-8 tracking-wide" data-id="element-200">
            SE LLAMA AGOTAMIENTO EMOCIONAL
          </h3>
          <div className="space-y-2 sm:space-y-4 text-base sm:text-xl text-cream-100/90" data-id="element-201">
            <p data-id="element-202">Y afecta a millones de mujeres que nadie ve.</p>
            <p data-id="element-203">Mujeres que dan todo.</p>
            <p data-id="element-204">Mujeres que aman profundamente.</p>
            <p data-id="element-205">Mujeres que sostienen familias enteras.</p>
            <p className="font-medium text-white pt-4" data-id="element-206">
              Mujeres que se olvidaron de sostenerse a sí mismas.
            </p>
            <p className="font-serif italic text-2xl text-amber-400 pt-4" data-id="element-207">
              Mujeres como tú.
            </p>
          </div>
        </div>
      </FadeIn>

      <FadeIn data-id="element-208">
        <h3 className="text-xl sm:text-3xl mb-6 sm:mb-10 text-center font-serif" data-id="element-209">
          Los Números que Nadie Habla
        </h3>

        <div className="grid grid-cols-2 gap-3 sm:gap-6 mb-8 sm:mb-16" data-id="element-210">
          {stats.map((item, i) => <div key={i} className="bg-navy-800 rounded-xl p-4 sm:p-6 border border-navy-700 flex flex-col items-center text-center" data-id="element-211">
              <span className="text-3xl sm:text-5xl font-serif text-rose-400 mb-2 sm:mb-4" data-id="element-212">
                {item.stat}
              </span>
              <p className="text-cream-100/80 text-sm sm:text-lg" data-id="element-213">
                {item.text}
              </p>
            </div>)}
        </div>

        <div className="text-center space-y-4 text-lg sm:text-xl text-cream-100/80 max-w-2xl mx-auto" data-id="element-214">
          <p className="text-white font-medium" data-id="element-215">
            Y sin embargo... casi ninguna busca ayuda.
          </p>
          <p data-id="element-216">Porque aprendieron que pedir es debilidad.</p>
          <p data-id="element-217">Porque creen que no tienen tiempo.</p>
          <p data-id="element-218">Porque piensan que primero tienen que estar todos bien.</p>
        </div>
      </FadeIn>
    </Section>;
};